let btns_abrir = document.getElementsByClassName('icono-menu');
let menu = document.getElementsByClassName('menu-top');
let btns_cerrar = document.getElementsByClassName('cerrar-mov');
let btns_li_cerrar = document.getElementsByClassName('li-cerrar-mov');
let btns_mas_qty = document.getElementById('mas-producto');
let btns_menos_qty = document.getElementById('menos-producto');
let btn_submenu = document.getElementById('abrir-submenu');
let tabs = document.getElementsByClassName('contenido-tab');
let altura_tab = 0;
var bloques_ocultos = document.getElementsByClassName('item-opinion oculto');
var bloques = document.getElementsByClassName('item-opinion');
var numero_bloques = bloques.length - 1;
var ancho = document.documentElement.clientWidth;
let vis  = sessionStorage.visita

if (!vis){
        window.onload = function () {
        //document.getElementById('btn-popup-2').click();
        sessionStorage.visita = true;
      }
}

vis  = sessionStorage.visita

if(btns_abrir){
    for ( let boton of btns_abrir ) {
        boton.onclick = function() {
            if(document.documentElement.clientWidth <= 1130){
                document.getElementById("menu-movil").style.display = "block";
                document.getElementById('shopify-section-minicarrito').classList.add('oculto');
                var body = document.body;
                body.classList.remove("carrito-abierto");
                //body.classList.remove("carrito-plegado-abierto");
            }
        }
    }
}

if(btns_cerrar){
    for ( let boton of btns_cerrar){
        boton.onclick = function() {
            //document.getElementById("menu-movil").classList.toggle('menuoculto');
            document.getElementById("menu-movil").style.display = "none";
            if(document.documentElement.clientWidth <= 1130){
                document.getElementById("submenu-movil").classList.toggle('submenuoculto');
            }
        }
    }
}

if(btns_li_cerrar){
    for ( let boton of btns_li_cerrar){
        boton.onclick = function() {
            if(document.documentElement.clientWidth <= 1130){
                document.getElementById("menu-movil").style.display = "none";
            }
        }
    }
}

if(btn_submenu){
    btn_submenu.onclick = function(){
        ancho = document.body.clientWidth;
        if(ancho <= 1130){
            document.getElementById("submenu-movil").classList.toggle('submenuoculto');
        }

    }
}

if(btns_menos_qty){
    btns_menos_qty.onclick = function() {
        let qty = parseInt(document.getElementById('quantity').value, 10);

        if(qty > 1){
            qty--;
            document.getElementById('quantity').value = qty;
        }
    }
}

if(btns_mas_qty){
    btns_mas_qty.onclick = function() {
        let qty = parseInt(document.getElementById('quantity').value, 10);

        qty++;
        document.getElementById('quantity').value = qty;
    }
}

if(tabs){
    for(let tab of tabs){
        if(tab.clientHeight > altura_tab){
            altura_tab = tab.clientHeight;
        }
        tab.style.minHeight = altura_tab + "px";

    }
}

// Click en ver más
if(document.getElementById('ver-mas')){
    document.getElementById('ver-mas').addEventListener('click', function() {
        if(bloques_ocultos[0]){
            bloques_ocultos[0].classList.remove('oculto');
            if(bloques_ocultos.length == 0){
                this.classList.toggle('oculto');
                this.scrollIntoView(true);
                document.getElementById('ver-menos').classList.toggle('oculto');
                numero_bloques = bloques.length - 1;
            }
        }
    });
}

if(document.getElementById('ver-menos')){
    document.getElementById('ver-menos').addEventListener('click', function() {
        if(numero_bloques > 0){
            bloques[numero_bloques].classList.toggle('oculto');
            numero_bloques--;
            if(numero_bloques == 0){
                this.classList.toggle('oculto');
                document.getElementById('ver-mas').classList.toggle('oculto');
                numero_bloques = bloques.length - 1;
            }
        }
    });
}



function obtener_variante(el){
    let valor = el.parentNode.getAttribute('data-value');
    let option = document.getElementById('option-' + valor);
    option.selected = true;
}


if(document.getElementById('ver-mas-twitter')){
    document.getElementById('ver-mas-twitter').addEventListener('click', function() {
        document.getElementById("opinionesTwitter").style.maxHeight = "100%";
    });
}

if(document.getElementById('ver-mas-general')){
    document.getElementById('ver-mas-general').addEventListener('click', function() {
        document.getElementById("recomendacionesFacebook").style.maxHeight = "100%";
    });
}

if(document.getElementById('ver-mas-facebook')){
    document.getElementById('ver-mas-facebook').addEventListener('click', function() {
        document.getElementById("opinionesFacebook").style.maxHeight = "100%";
    });
}


// Cookie bar
jQuery('.cerrar-cookie').click(function(){
    var now = new Date();
    var time = now.getTime();
    time += 432000 * 1000;
    now.setTime(time);
    document.cookie = 'Aceptadas Cookies = True; expires=' + now.toUTCString() + '; path=/';

    jQuery(this).parent().parent().addClass('noactive');
});

// Set Cookie
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {
    var username = getCookie("Aceptadas Cookies");

    if (username != "") {
        jQuery('#cookieBar').addClass('noactive')
    }else{
        jQuery('#cookieBar').addClass('active')
    }
}

/**
 * Obtiene el referer
 */
function esWebview(){

    var ref = document.referrer;

    if(ref.includes("bnext")){
        $('#cookieBar').addClass('noactive');
        document.cookie = "Aceptadas Cookies = True";
        $('#intercom-container').css( "display", "none" );
    }

    return ref;

}

esWebview();
checkCookie();


jQuery('.txt-islas').click(function () {
    jQuery('.popup-islas').toggle();
});

$(document).mouseup(function(e)
{
    var container = $('.txt-islas');
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        jQuery('.popup-islas').hide();
    }
});

